<template>
  <div>
    <b-table :items="glossary_items" hover striped bordered></b-table>
  </div>
</template>

<script>
import axios from "axios";
import {fullURL} from "@/utils";
import store from "@/store";

export default {
  data() {
    return {
      glossary_items: []
    }
  },

  created() {
    const glossaries = store.state.general.glossary
    if (glossaries) {
      glossaries.forEach(glossary => {
        this.glossary_items.push({terminology: glossary["name"], definition: glossary["value"]})
      })
    } else {
      axios.get(
      fullURL(`/dashboards/glossary/all`)
    ).then(({data}) => {
      data.forEach(glossary => {
          this.glossary_items.push({terminology: glossary["name"], definition: glossary["value"]})
        })
        store.state.general.glossary = data
      }
    )
    }
  },
}
</script>
